// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BookingSearchFormComponent } from './booking-search-form.component';
import { CardFormModule } from 'libraries/module/formbuilder/forms/card-form/card-form.module';
import { ButtonModule } from 'libraries/module/formbuilder/fields/button/button.module';
import { ChipsModule } from 'libraries/module/formbuilder/fields/chips/chips.module';
import { PopupMenuModule } from 'libraries/component/popup-menu/popup-menu.module';
import { FieldDescriptionModule } from 'libraries/module/formbuilder/fields/form-field/components/field-description/field-description.module';
import { FieldsetsModule } from './fieldsets/fieldsets.module';
import { ConfigFieldBuilderService } from './config-field-builder.service';
import { SsrServiceModule } from 'libraries/service/ssrs/SsrsService.module';
import { EnumsResourceModule } from 'libraries/service/booking/enums/enums-resource.module';
import { SearchUtilsService } from "app_sasha/shared/models/search-utils.service";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { PermissionModule } from "libraries/permission/permission.module";

@NgModule({
    imports: [
        ButtonModule,
        CardFormModule,
        ChipsModule,
        CommonModule,
        EnumsResourceModule,
        FieldDescriptionModule,
        FieldsetsModule,
        FontAwesomeModule,
        PopupMenuModule,
        SsrServiceModule,
        PermissionModule,
    ],
    declarations: [
        BookingSearchFormComponent,
    ],
    exports: [
        BookingSearchFormComponent,
    ],
    providers: [
        ConfigFieldBuilderService,
        SearchUtilsService,
    ]
})
export class BookingSearchFormModule {  }
